import React from 'react'
import cx from 'classnames'

import { useKeyDown } from 'common/core/coreHooks'

import cm from './RateButton.module.css'

interface RateButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  emoji: string
  keyCode: string
  onClick: () => void
}

export const RateButton = ({ emoji, keyCode, className, onClick, ...props }: RateButtonProps) => {
  useKeyDown({
    key: keyCode,
    onPress: onClick,
  })

  return (
    <button className={cx(cm.rateButton, className)} onClick={onClick} {...props}>
      <img src={emoji} width={40} height={40} aria-hidden />
    </button>
  )
}
